import jQuery from 'jquery'

(function($) {
  "use strict";
  $(document).ready(function() {
    // ADD COMPANY MEMBER CONTAINER OBSERVER
    if ($('#registrations__companies__new').length) {
      const $members_container = $('#members_container'),
            max = $members_container.data('max'),
            $add_member_btn_container = $('#add_member_btn_container');

      const reset_members_container = function() {
        // SET ADD MEMBER BUTTON
        if ($('#members_container .company-member').length >= max) {
          if ($add_member_btn_container.is(':visible')) $add_member_btn_container.hide();
        } else {
          if ($add_member_btn_container.is(':hidden')) $add_member_btn_container.show();
        }

        // SET DELETE MEMBER BUTTON
        $('#members_container .company-member .delete-member').unbind('click');
        $('#members_container .company-member .delete-member').bind('click', function() {
          const $company_member_container = $(this).closest('.company-member');
          $company_member_container.slideUp(function() {
            $company_member_container.remove();
          });
        });

        // SET MEMBER COUNTER
        const $counters = $('#members_container .company-member .member-counter');
        $counters.text('');
        for (var i = 0, len = $counters.length; i < len; i += 1) {
          $counters.eq(i).text(i + 2);
        }
      }

      const watch_member_container = function() {
        const observer = new MutationObserver(records => {
          reset_members_container();
        });

        observer.observe($members_container[0], { childList: true });
      }

      reset_members_container();
      watch_member_container();
    }
    
    $('.match-height').matchHeight();
    
  });

})(jQuery);
